<template>
  <div class=" w-100 px-4 px-lg-5 pb-5 text-light">

    <div>
      <h3 class="my-font my-color mt-3 mb-4">شرکای کوپابی</h3>
      <div class="img-section row justify-content-lg-center px-lg-4">
        <img class="col-12 col-lg-4 mx-auto my-3 " src="/img/logos.jpg" alt="">
      </div>
      <div id="amadeh-laziz">
        <h4 class="my-font my-color  mt-4">گروه صنایع غذایی آماده لذیذ</h4>
        <h6 class="my-font my-color">شریک راهبردی کوپابی</h6>
        <img src="/img/f1.png" width="150px" alt="">
        <p class="mt-4">
          آماده لذیذ از سال ۱۳۷۹ فعالیت خود را با تولید محصولات غذایی متنوع آغاز کرده و امروز با بیش از دو دهه تجربه، ۴
          کارخانه صنعتی در زمینی به وسعت ۸۰٬۰۰۰ مترمربع و بیش از ۲٬۱۰۰ نیروی انسانی متخصص، به‌عنوان یکی از نام‌های بزرگ
          صنعت غذا در ایران شناخته می‌شود.
          با تمرکز بر کیفیت، نوآوری و توزیع گسترده، این مجموعه به عنوان شریک راهبردی کوپابی در حوزه تولید نقشی کلیدی
          ایفا
          می‌کند.
        </p>
        <h4 class="my-font my-color  mt-4">ظرفیت‌های اجرایی و لجستیکی آماده لذیذ</h4>

        <h6 class="my-font my-color  mt-4">شبکه توزیع سراسری و مویرگی (شرکت پخش آلپا)</h6>
        <p class="mt-4">
          با بیش از ۴۲ شعبه فعال، ۲۵۶ خودرو توزیع، ۴۵٬۰۰۰ متر انبار اختصاصی و پوشش بیش از ۱۳۰٬۰۰۰ نقطه فروش در سراسر
          کشور،
          یکی از بزرگ‌ترین شبکه‌های توزیع FMCG در ایران را در اختیار دارد.
        </p>

        <h6 class="my-font my-color  mt-4">توزیع در فروشگاه‌های زنجیره‌ای</h6>
        <p class="mt-4">
          همکاری با بیش از ۲۵ گروه فروشگاهی و تیمی حرفه‌ای در بخش زنجیره‌ای، بیش از ۱۰٬۰۰۰ فروشگاه بزرگ را در سطح کشور
          تحت
          پوشش دارد.
        </p>


        <h6 class="my-font my-color  mt-4">تیم تخصصی مارکتینگ و ترید</h6>
        <p class="mt-4">
          با ۷۰۰ نیروی فعال در بخش‌های مدیریت برند، تحقیقات بازار، تبلیغات، CRM، تولید محتوا و ترید مارکتینگ، فعالیت‌های
          بازاریابی این مجموعه کاملاً علمی، هدفمند و مبتنی بر داده انجام می‌شود.
        </p>

      </div>
      <div id="zanboor-daran">
        <h4 class="my-font my-color  mt-4">اتحادیه سراسری زنبورداران ایران</h4>
        <h6 class="my-font my-color">بازوی تخصصی زنبورداری کشور</h6>
        <img src="/img/f4.png" width="150px" alt="">
        <p class="mt-4">
          اتحادیه سراسری زنبورداران ایران از سال ۱۳۸۵ به‌عنوان تنها نهاد رسمی زنبورداری کشور فعالیت دارد و با ۲۵۶ شرکت
          تعاونی در سراسر کشور، نماینده بیش از ۱۰۰٬۰۰۰ زنبوردار ایرانی است. این اتحادیه مسئول هماهنگی و پشتیبانی از ۱۰.۶
          میلیون کلنی زنبورعسل در ایران است.
          با تولید سالانه بیش از ۱۱۲٬۵۰۰ تن عسل و جایگاه چهارم جهانی در این حوزه، اتحادیه نقش مؤثری در توسعه صنعت
          زنبورداری و حمایت از محصولات استراتژیک مانند ژل رویال، گرده گل و موم ایفا می‌کند.
        </p>
        <h4 class="my-font my-color  mt-4">ظرفیت‌های کلیدی</h4>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              دارای آزمایشگاه تخصصی و پیشرفته برای بررسی کیفیت عسل و فرآورده‌های زنبور
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              شبکه توزیع گسترده نهاده‌ها و تجهیزات زنبورداری
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              عضو رسمی و فعال فدراسیون جهانی زنبورداری (Apimondia)
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              برگزارکننده کنگره‌ها، دوره‌های آموزشی و نمایشگاه‌های تخصصی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              مرجع صدور پروانه فعالیت حرفه‌ای زنبورداری در کشور
            </p>
          </li>
        </ul>

      </div>
      <div id="beheshti">
        <h4 class="my-font my-color  mt-4">پژوهشکده گیاهان و مواد اولیه دارویی</h4>
        <h6 class="my-font my-color">دانشگاه شهید بهشتی</h6>
        <img src="/img/f3.png" width="150px" alt="">
        <p class="mt-4">
          پژوهشکده گیاهان دارویی دانشگاه شهید بهشتی، از مراکز پیشرو در حوزه تحقیقات زیستی و دارویی کشور است. این بخش با
          بزرگ‌ترین هرباریوم تخصصی گیاهان دارویی، زیرساخت‌های پیشرفته آنالیز شیمیایی و زیستی، و توانایی استخراج و
          خالص‌سازی ترکیبات فعال از منابع طبیعی، به‌عنوان مرجع علمی در سطح ملی و بین‌المللی شناخته می‌شود.
          کوپابی در توسعه فرمولاسیون‌های خود، از ظرفیت این پژوهشکده برای پایش، آزمایش و اعتبارسنجی ترکیبات طبیعی و ایمن
          مورد استفاده در تغذیه زنبور عسل بهره می‌برد.
        </p>
        <h4 class="my-font my-color  mt-4">محورهای همکاری با کوپابی</h4>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              طراحی و بهینه‌سازی تغذیه تخصصی زنبورعسل با رویکرد فصلی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              بررسی فعالیت زیستی و ایمنی ترکیبات طبیعی مورد استفاده
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              جایگزینی تغذیه زمستانی سنتی با خوراک های غنی‌شده و علمی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              ارتقاء کیفیت عسل از محصول غذایی به فرآورده‌ای با ارزش دارویی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              تحقیق و توسعه داروهای طبیعی، ارگانیک و بدون مواد شیمیایی برای پیشگیری و درمان بیماری‌های زنبورعسل
            </p>
          </li>
        </ul>

      </div>
      <div id="actoteck">
        <h4 class="my-font my-color  mt-4">شتاب‌دهنده دارویی و غذایی اکتوتک</h4>
        <!--        <h6 class="my-font my-color"></h6>-->
        <img src="/img/f2.png" width="150px" alt="">
        <p class="mt-4">
          شتاب‌دهنده اکتوتک در سال ۱۳۹۸ با هدف توسعه نوآوری در حوزه غذا و دارو و در راستای سند چشم‌انداز سلامت کشور، در
          پارک علم و فناوری دانشگاه صنعتی شریف تأسیس شد و در مرداد ۱۳۹۹ با حضور معاون علمی و فناوری ریاست‌جمهوری به
          بهره‌برداری رسید.
          این مجموعه به‌عنوان یک شتاب‌دهنده پیشرو در اتصال دانشگاه و صنعت، فضایی را فراهم کرده است تا ایده‌های نوآورانه
          دانش‌بنیان با حمایت علمی و زیرساختی، به مرحله اجرا و تولید برسند. اکتوتک با در اختیار داشتن آزمایشگاه صنعتی
          پیشرفته، امکان انجام پروژه‌های تحقیقاتی و توسعه‌ای را برای استارتاپ‌ها، پژوهشگران و فعالان حوزه سلامت فراهم
          کرده است.
          در سال ۱۴۰۰، همکاری رسمی بین اکتوتک و پژوهشکده گیاهان و مواد اولیه دارویی دانشگاه شهید بهشتی با هدف بهبود
          فرآیندهای شتابدهی و ارتقای علمی پروژه‌ها آغاز شد و منجر به امضای تفاهم‌نامه مشترک شد.
          اکتوتک، به عنوان شتاب‌دهنده تخصصی طرح خمیر شیرین (تغذیه) زنبور عسل، پس از موفقیت در مرحله تولید آزمایشگاهی، با
          همراهی دانشگاه شهید بهشتی، فاز نیمه‌صنعتی این محصول را توسعه داد و در ادامه با برند کوپابی، تولید صنعتی این
          محصول نوآورانه را آغاز کرد.
        </p>
        <h4 class="my-font my-color  mt-4">محورهای همکاری با کوپابی</h4>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              بهره‌گیری از زیرساخت‌های آزمایشگاهی برای توسعه فرمولاسیون‌های علمی و ایمن در تغذیه زنبورعسل
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              طراحی و اجرای پروژه‌های تحقیق و توسعه (R&D) مشترک با رویکرد سلامت‌محور
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              شبکه‌سازی علمی بین دانشگاهیان، استارتاپ‌ها و صنایع غذایی و دارویی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              برگزاری نشست‌های تخصصی و کلاس‌های آموزشی در زمینه تغذیه کاربردی و زیستی
            </p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">
              حمایت از پروژه‌های نوآورانه در زمینه تغذیه درمانی، محصولات طبیعی و فراسودمند
            </p>
          </li>
        </ul>

      </div>


    </div>
  </div>

</template>

<script>
export default {
  name: "Participants"
}
</script>

<style scoped>
li p{
  font-size: 14px;
}
</style>